import { xyGrowingX } from 'ml-spectra-processing';
/**
 * Ensure X values are strictly monotonic increasing
 * http://www-groups.mcs.st-andrews.ac.uk/~john/analysis/Lectures/L8.html
 * @param data
 */
export function reverseIfNeeded(data) {
    return { data: xyGrowingX(data) };
}
//# sourceMappingURL=reverseIfNeeded.js.map